import { UseFormRegister } from "react-hook-form";
import { useIntl } from "react-intl";
import { styled } from "stitches.config";
import { Input } from "../form";
import { MonthlyPaymentsFormValues } from "@/hooks/simulators/useMonthlyPaymentsSimulatorForm";

export type MonthlyPaymentsFormProps = {
    register: UseFormRegister<MonthlyPaymentsFormValues>;
}

export const MonthlyPaymentsForm = ({ register }: MonthlyPaymentsFormProps) => {
    const { formatMessage } = useIntl();

    return (
      <FormContainer>
        <Input
          autoFocus
          type="number"
          suffix={formatMessage({ id: 'monthly_payments_simulator.form.loan_capital.suffix' })}
          label={formatMessage({ id: 'monthly_payments_simulator.form.loan_capital.label' })}
          tooltipInfos={formatMessage({ id: 'monthly_payments_simulator.form.loan_capital.tooltip' })}
          placeholder={formatMessage({ id: 'monthly_payments_simulator.form.loan_capital.placeholer' })}
          {...register('loan_capital', {
            valueAsNumber: true,
          })}
         />
        <Input
          type="number"
          suffix={formatMessage({ id: 'monthly_payments_simulator.form.duration.suffix' })}
          label={formatMessage({ id: 'monthly_payments_simulator.form.duration.label' })}
          placeholder={formatMessage({ id: 'monthly_payments_simulator.form.duration.placeholer' })}
          {...register('duration', {
            valueAsNumber: true,
          })}
         />
        <Input
          type="number"
          suffix={formatMessage({ id: 'monthly_payments_simulator.form.interest_rate.suffix' })}
          label={formatMessage({ id: 'monthly_payments_simulator.form.interest_rate.label' })}
          tooltipInfos={formatMessage({ id: 'monthly_payments_simulator.form.interest_rate.tooltip' })}
          placeholder={formatMessage({ id: 'monthly_payments_simulator.form.interest_rate.placeholer' })}
          {...register('interest_rate', {
            valueAsNumber: true,
          })}
         />
        <Input
          type="number"
          suffix={formatMessage({ id: 'monthly_payments_simulator.form.insurance_rate.suffix' })}
          label={formatMessage({ id: 'monthly_payments_simulator.form.insurance_rate.label' })}
          tooltipInfos={formatMessage({ id: 'monthly_payments_simulator.form.insurance_rate.tooltip' })}
          placeholder={formatMessage({ id: 'monthly_payments_simulator.form.insurance_rate.placeholer' })}
          {...register('insurance_rate', {
            valueAsNumber: true,
          })}
         />
      </FormContainer>
    )
}

const FormContainer = styled('section', {
    gap: '$8',
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '1px solid $borderSecondary',
    padding: '$10',
    '@sm': {
      border: 'none',
      padding: '$8',
    },
});